<template>
  <div v-if="isHydrated" class="contact-popup-wrapper">
    <div>
      <div class="contact-desktop">
        <ContactPopupPC>
          <template #trigger>
            <slot name="trigger"></slot>
          </template>
        </ContactPopupPC>
      </div>

      <div class="contact-mobile">
        <ContactPopupMobile>
          <template #trigger>
            <slot name="trigger"></slot>
          </template>
        </ContactPopupMobile>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import ContactPopupMobile from './ContactPopupMobile.vue'
import ContactPopupPC from './ContactPopupPC.vue'

const isHydrated = ref(false)

onMounted(() => {
  isHydrated.value = true
})
</script>

<style lang="scss" scoped>
.contact-popup-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.contact-desktop {
  display: block;

  @include respond-to-max('lg') {
    display: none;
  }
}

.contact-mobile {
  display: none;

  @include respond-to-max('lg') {
    display: block;
  }
}
</style>
